import {UserPublicProfile} from "../../user-service/user-service";

export class EventParticipant {

  static readonly CHAT_ACCESSIBILITY_DISABLED = -1;
  static readonly CHAT_ACCESSIBILITY_DEFAULT = 0;
  static readonly CHAT_ACCESSIBILITY_PRIVATE = 1;
  static readonly CHAT_ACCESSIBILITY_SEARCHABLE = 2;

  static readonly ROLE_PARTICIPANT: number = 0;
  static readonly ROLE_STUDIO_DELEGATE: number = 10;
  static readonly ROLE_COMPETITION_DELEGATE: number = 100;

  static readonly DEFAULT_ROLE = {
    id: EventParticipant.ROLE_PARTICIPANT,
    name: 'spectator'
  };

  profile: UserPublicProfile;

  get displayName() : string {
    let value: string = null;

    if (this._displayName) {
      value = this._displayName;
    } else if (this.profile) {
      value = this.profile.displayName;
    }

    return value;
  }

  get photo() : string {
    let value: string = null;

    if (this._photo) {
      value = this._photo;
    } else if (this.profile) {
      value = this.profile.photo;
    }

    return value;
  }

  get isBlocked() : boolean {
    return this.accessibility < EventParticipant.CHAT_ACCESSIBILITY_DEFAULT;
  }

  public constructor(public id: string,
                     public role: number = 0,
                     public roleName: string = null,
                     public accessibility: number = 0,
                     private _displayName: string = null,
                     private _photo: string = null) {

  }

  static fromAngularFireSnapshot(snap: any) : EventParticipant {
    return EventParticipant._fromSnapshot(snap.key, snap.payload.val())
  }

  static fromSnapshot(snap: any) : EventParticipant {
    return EventParticipant._fromSnapshot(snap.key, snap.val());
  }

  static fromAngularFireSnapshots(snapshots: any) : EventParticipant[] {
    return snapshots.map(snap => EventParticipant._fromSnapshot(snap.key, snap.payload.val()));
  }

  private static _fromSnapshot(key: string, {role, roleName, accessibility, displayName, photo}) {
    return new EventParticipant(key, role, roleName, accessibility, displayName, photo);
  }
}



// WEBPACK FOOTER //
// ./src/providers/communication/models/EventParticipant.ts